import React, { lazy } from "react"

import { RouteObject } from "react-router"

const ReportPage = lazy(() => import("./ReportPage"))

export const ReportsRoutes: RouteObject[] = [
	{ path: "", element: <ReportPage /> },
]
